<div *ngIf="comm.progressBar" id="progressBar" class="success progress loop">
  <progress></progress>
</div>
